import { requestTimeout, handleResponse } from "../utils";

const apiUrl = process.env.REACT_APP_API_URL;
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME;

export const contactApi = {
  _contactUs,
};

async function _contactUs(payload) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/contact-us", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}
